module.exports = __webpack_public_path__ + "src/assets/games/49/yun.png";